import { motion } from "framer-motion";
import { ArrowUpRight, BedDouble, Bath, Ruler, MapPin } from "lucide-react";

const NEW_LISTING = {
  address: "1737 Mable Ave",
  city: "Modesto, CA",
  beds: 5,
  baths: 3,
  sqft: "1,319",
  image:
    "https://customer-assets-jai6qajn.emergentagent.net/job_watson-group-realty/artifacts/em6ilz5o_IMG_2743.webp",
  link: "https://www.zillow.com/homedetails/1737-Mable-Ave-Modesto-CA-95355/16064629_zpid/",
};

export default function NewListing() {
  return (
    <section
      id="new-listing"
      data-testid="new-listing-section"
      className="relative bg-[#0A0A0A] py-32 md:py-44 px-6 md:px-12 border-b border-white/5 overflow-hidden"
    >
      <div className="mx-auto max-w-[1500px] grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
        {/* Image */}
        <motion.div
          initial={{ opacity: 0, scale: 1.06 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1] }}
          className="md:col-span-7 relative"
        >
          <div className="relative aspect-[4/3] md:aspect-[5/4] overflow-hidden bg-[#121212]">
            <img
              src={NEW_LISTING.image}
              alt={NEW_LISTING.address}
              className="w-full h-full object-cover"
              style={{ filter: "grayscale(15%) brightness(0.94)" }}
            />
            <div
              data-testid="new-listing-badge"
              className="absolute top-4 left-4 overline text-[#0A0A0A] bg-[#CBBFAE] px-3 py-1.5 rounded-full"
            >
              New Listing
            </div>
          </div>
        </motion.div>

        {/* Copy */}
        <div className="md:col-span-5 md:pl-4">
          <p className="overline text-[#CBBFAE] mb-6">Just Listed</p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.9 }}
            className="font-serif text-5xl md:text-7xl leading-[0.95] tracking-tight text-white mb-6"
            data-testid="new-listing-address"
          >
            {NEW_LISTING.address}
          </motion.h2>

          <div className="flex items-center gap-2 text-white/60 mb-10">
            <MapPin size={16} className="text-[#CBBFAE]" />
            <span className="text-sm md:text-base">{NEW_LISTING.city}</span>
          </div>

          <div className="grid grid-cols-3 gap-3 md:gap-4 mb-12 max-w-md">
            <div
              data-testid="new-listing-beds"
              className="border border-white/10 rounded-md px-4 py-5 flex flex-col items-start"
            >
              <BedDouble size={18} className="text-[#CBBFAE] mb-3" />
              <div className="font-serif text-3xl text-white leading-none">{NEW_LISTING.beds}</div>
              <div className="overline text-white/40 mt-2">Beds</div>
            </div>
            <div
              data-testid="new-listing-baths"
              className="border border-white/10 rounded-md px-4 py-5 flex flex-col items-start"
            >
              <Bath size={18} className="text-[#CBBFAE] mb-3" />
              <div className="font-serif text-3xl text-white leading-none">{NEW_LISTING.baths}</div>
              <div className="overline text-white/40 mt-2">Baths</div>
            </div>
            <div
              data-testid="new-listing-sqft"
              className="border border-white/10 rounded-md px-4 py-5 flex flex-col items-start"
            >
              <Ruler size={18} className="text-[#CBBFAE] mb-3" />
              <div className="font-serif text-3xl text-white leading-none">{NEW_LISTING.sqft}</div>
              <div className="overline text-white/40 mt-2">Sq Ft</div>
            </div>
          </div>

          <a
            data-testid="new-listing-see-more"
            href={NEW_LISTING.link}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3 border border-[#CBBFAE]/60 hover:border-[#CBBFAE] rounded-full pl-6 pr-2 py-2 text-[12px] tracking-[0.25em] uppercase text-white transition-all"
          >
            <span>See More</span>
            <span className="w-9 h-9 rounded-full bg-[#CBBFAE] text-[#0A0A0A] flex items-center justify-center transition-transform group-hover:rotate-45">
              <ArrowUpRight size={16} />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
